export default __webpack_public_path__ + "static/media/sass.c7c12f81.svg";